import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import constants from '../config';
import logoLight from './assets/logo.svg';
import logoDark from './assets/logo-gold.svg';

class VerifyEmail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      success: false,
      error: '',
      isDark: document.documentElement.classList.contains('tw-dark'),
    };
    this._darkObserver = null;
  }

  componentDidMount() {
    var comp = this;
    this._darkObserver = new MutationObserver(function() {
      var dark = document.documentElement.classList.contains('tw-dark');
      if (dark !== comp.state.isDark) comp.setState({ isDark: dark });
    });
    this._darkObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

    const token = this.props.match.params.token;
    fetch(`${constants.DOMAIN}/api/v1/users/verify-email`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token }),
    })
      .then(res => res.json())
      .then(data => {
        if (data.error) {
          this.setState({ loading: false, error: data.error });
        } else {
          this.setState({ loading: false, success: true });
          // Update verified status in localStorage so the banner disappears
          localStorage.setItem('primal_verified', 'true');
          window.dispatchEvent(new Event('authStateChanged'));
        }
      })
      .catch(() => {
        this.setState({ loading: false, error: 'Something went wrong. Please try again.' });
      });
  }

  componentWillUnmount() {
    if (this._darkObserver) this._darkObserver.disconnect();
  }

  render() {
    const { loading, success, error, isDark } = this.state;

    return (
      <div className="tw-min-h-screen tw-bg-[#fafafa] dark:tw-bg-[#0a0a0a] tw-flex tw-items-center tw-justify-center tw-p-4">
        <div className="tw-max-w-md tw-w-full tw-bg-white dark:tw-bg-[#1a1a2e] tw-rounded-2xl tw-shadow-lg tw-p-8 tw-text-center">
          <div className="tw-flex tw-justify-center tw-mb-6">
            <img src={isDark ? logoDark : logoLight} alt="Primal Market" className="tw-h-14 tw-w-auto" />
          </div>

          {loading && (
            <>
              <div className="tw-text-4xl tw-mb-4" style={{ color: '#c9a84c' }}>
                <i className="fa fa-spinner fa-spin" />
              </div>
              <h2 className="tw-text-xl tw-font-bold tw-text-[#1a1a1a] dark:tw-text-white tw-mb-2">
                Verifying...
              </h2>
              <p className="tw-text-[#666] dark:tw-text-gray-400 tw-text-sm">
                Please wait while we verify your email.
              </p>
            </>
          )}

          {success && (
            <>
              <div className="tw-text-5xl tw-mb-4" style={{ color: '#10b981' }}>
                <i className="fa fa-check-circle" />
              </div>
              <h2 className="tw-text-xl tw-font-bold tw-text-[#1a1a1a] dark:tw-text-white tw-mb-2">
                Email Verified!
              </h2>
              <p className="tw-text-[#666] dark:tw-text-gray-400 tw-text-sm tw-mb-6">
                Your email has been successfully verified. You're all set!
              </p>
              <Link
                to="/"
                className="tw-inline-block tw-w-full tw-py-3 tw-rounded-lg tw-bg-brand-gold hover:tw-bg-brand-gold-dark tw-text-black tw-font-bold tw-text-sm tw-no-underline tw-transition-colors tw-text-center"
              >
                Go to Marketplace
              </Link>
            </>
          )}

          {error && (
            <>
              <div className="tw-text-5xl tw-mb-4" style={{ color: '#ef4444' }}>
                <i className="fa fa-times-circle" />
              </div>
              <h2 className="tw-text-xl tw-font-bold tw-text-[#1a1a1a] dark:tw-text-white tw-mb-2">
                Verification Failed
              </h2>
              <p className="tw-text-[#666] dark:tw-text-gray-400 tw-text-sm tw-mb-6">
                {error}
              </p>
              <Link
                to="/"
                className="tw-inline-block tw-w-full tw-py-3 tw-rounded-lg tw-bg-brand-gold hover:tw-bg-brand-gold-dark tw-text-black tw-font-bold tw-text-sm tw-no-underline tw-transition-colors tw-text-center"
              >
                Go to Marketplace
              </Link>
            </>
          )}
        </div>
      </div>
    );
  }
}

export default VerifyEmail;
